import Profile from './profile'
import Integrations from './integrations.vue'
import Memory from './memory'
import Superuser from './superuser'
import Admin from './admin'
import Analytics from 'pages/settings/analytics/analytics.vue'

import $profile from 'stores/profile'
import $global from 'stores/global'

const __default__ = {
  computed: {
    is_superuser() {
      return $profile.is_superuser
    },
    is_admin() {
      return $profile.is_admin
    },
    tabs() {
      const result = [
        {value: 'profile', title: 'Profile'},
        {value: 'integrations', title: 'Connectors'},
        {value: 'memory', title: 'Memory'}
      ]
      if (this.is_admin) {
        result.push({value: 'analytics', title: 'Analytics'})
        result.push({value: 'admin', title: 'Admin'})
      }
      if (this.is_superuser) {
        result.push({value: 'superuser', title: 'Superuser'})
      }
      return result
    },
    active: {
      get(){
        return this.$route.query.tab
      },
      set(val){
        $global.goToSettings(val)
      }
    },
  },
  beforeMount(){
    const {tab} = this.$route.query
    if (tab && this.tabs.some(x => x.value === tab)) return
    $global.goToSettings('profile', {replace: true})
  }
}


export default /*@__PURE__*/Object.assign(__default__, {
  __name: 'settings',
  setup(__props, { expose: __expose }) {
  __expose();


const __returned__ = { get $profile() { return $profile }, get $global() { return $global }, get Profile() { return Profile }, Integrations, get Memory() { return Memory }, get Superuser() { return Superuser }, get Admin() { return Admin }, Analytics }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})